import { render, staticRenderFns } from "./IssueFastFerryEndorsement.vue?vue&type=template&id=71db74d4&scoped=true"
import script from "./IssueFastFerryEndorsement.vue?vue&type=script&lang=ts"
export * from "./IssueFastFerryEndorsement.vue?vue&type=script&lang=ts"
import style0 from "./IssueFastFerryEndorsement.vue?vue&type=style&index=0&id=71db74d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71db74d4",
  null
  
)

export default component.exports